import React from 'react';
import { SEO } from '../components/SEO';
import { Container } from '../components/ui/Container';
import { Button } from '../components/ui/Button';
import { MessageSquare, ExternalLink } from 'lucide-react';
export function ContactPage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: 'Contact Flowsense',
    description: 'Get in touch with Flowsense support team via live chat',
    mainEntity: {
      '@type': 'Organization',
      name: 'Flowsense',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'Customer Support',
        availableLanguage: 'English'
      }
    }
  };
  return <>
      <SEO title="Contact Us - Flowsense" description="Get in touch with Flowsense support. Chat with us directly in the app for instant help with Klaviyo flow optimization, pricing, features, and technical support." canonical="https://www.useflowsense.com/contact" structuredData={structuredData} data-id="element-393" />
      <div className="bg-white" data-id="element-394">
        {/* Hero */}
        <div className="bg-gray-900 py-20 lg:py-32 text-center text-white" data-id="element-395">
          <Container data-id="element-396">
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl mb-6" data-id="element-397">
              Get in Touch
            </h1>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-398">
              Have questions? Chat with us directly in the Flowsense app for
              instant support.
            </p>
          </Container>
        </div>

        {/* Contact Section */}
        <section className="py-24" data-id="element-399">
          <Container data-id="element-400">
            <div className="max-w-3xl mx-auto" data-id="element-401">
              <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-3xl p-12 text-center border border-indigo-100 shadow-xl" data-id="element-402">
                <div className="inline-flex items-center justify-center p-4 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 rounded-2xl mb-8" data-id="element-403">
                  <MessageSquare className="h-12 w-12 text-white" data-id="element-404" />
                </div>

                <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-405">
                  Live Chat Support
                </h2>

                <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-406">
                  Users can communicate with us through Live Chat in the app.
                  Our support team is available 24/7 to help you with any
                  questions about Flowsense.
                </p>

                <div className="bg-white rounded-xl p-6 mb-8 border border-gray-200 shadow-sm" data-id="element-407">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-408">
                    How to Access Live Chat
                  </h3>
                  <ol className="text-left text-gray-600 space-y-2" data-id="element-409">
                    <li className="flex items-start" data-id="element-410">
                      <span className="font-bold text-indigo-600 mr-2" data-id="element-411">1.</span>
                      <span data-id="element-412">Log in to your Flowsense account</span>
                    </li>
                    <li className="flex items-start" data-id="element-413">
                      <span className="font-bold text-indigo-600 mr-2" data-id="element-414">2.</span>
                      <span data-id="element-415">
                        Look for the chat icon in the bottom-right corner
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-416">
                      <span className="font-bold text-indigo-600 mr-2" data-id="element-417">3.</span>
                      <span data-id="element-418">Click to start chatting with our support team</span>
                    </li>
                  </ol>
                </div>

                <a href="https://app.useflowsense.com" target="_blank" rel="noopener noreferrer" data-id="element-419">
                  <Button size="lg" className="px-8" rightIcon={<ExternalLink className="h-5 w-5" data-id="element-421" />} data-id="element-420">
                    Open Flowsense App
                  </Button>
                </a>
              </div>

              <div className="mt-12 grid md:grid-cols-2 gap-6" data-id="element-422">
                <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm" data-id="element-423">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-424">
                    📚 Help Center
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-425">
                    Browse our comprehensive knowledge base for instant answers
                    to common questions.
                  </p>
                  <a href="/help" data-id="element-426">
                    <Button variant="outline" size="sm" data-id="element-427">
                      Visit Help Center
                    </Button>
                  </a>
                </div>

                <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm" data-id="element-428">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-429">
                    🚀 Resources
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-430">
                    Explore guides, tutorials, and best practices for flow
                    optimization.
                  </p>
                  <a href="/resources" data-id="element-431">
                    <Button variant="outline" size="sm" data-id="element-432">
                      View Resources
                    </Button>
                  </a>
                </div>
              </div>

              <div className="mt-12 p-6 bg-gray-50 rounded-lg text-center" data-id="element-433">
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-434">
                  Flowsense by Acciom Limited
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-435">
                  We're committed to helping brands optimize their email
                  marketing flows with AI-powered insights.
                </p>
              </div>
            </div>
          </Container>
        </section>
      </div>
    </>;
}